import { render, staticRenderFns } from "./MyCarousel2.vue?vue&type=template&id=b65f072e&scoped=true&"
import script from "./MyCarousel2.vue?vue&type=script&lang=js&"
export * from "./MyCarousel2.vue?vue&type=script&lang=js&"
import style0 from "./MyCarousel2.vue?vue&type=style&index=0&id=b65f072e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65f072e",
  null
  
)

export default component.exports